import MessageToast from "sap/m/MessageToast";

const SUCCESS_CLASS = "sapMMessageToastSuccess";
const ERROR_CLASS = "sapMMessageToastError";
const WARNING_CLASS = "sapMMessageToastWarning";

export default class ToastUtil {

  public static showSuccess(sMessage: string): void {
    MessageToast.show(sMessage);
    ToastUtil.styleLastToast(true);
  }

  public static showError(sMessage: string): void {
    MessageToast.show(sMessage);
    ToastUtil.styleLastToast(false);
  }

  private static styleLastToast(bSuccess: boolean): void {
    setTimeout(() => {
      const oToasts = document.querySelectorAll<HTMLElement>(".sapMMessageToast");
      if (oToasts.length === 0) {
        return;
      }

      const oToast = oToasts[oToasts.length - 1];
      oToast.classList.remove(SUCCESS_CLASS, ERROR_CLASS, WARNING_CLASS);
      oToast.classList.add(bSuccess ? SUCCESS_CLASS : ERROR_CLASS);

      if (!oToast.querySelector(".customToastIcon")) {
        const oIcon = document.createElement("span");
        oIcon.className = "customToastIcon";
        oIcon.style.fontFamily = "SAP-icons";
        oIcon.style.marginRight = "0.5rem";
        oIcon.style.color = bSuccess ? "#4F8A10" : "#D8000C";
        oIcon.textContent = bSuccess ? "\uE1C1" : "\uE03D";
        oToast.prepend(oIcon);
      }
    }, 0);
  }
}
